import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import classNames from 'classnames';
import Helmet from 'react-helmet';

import Icon from 'react-fa';

import { api, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Links extends Component {
  render() {

    const page = this.props.page;
    const links = page.acf.links;

    return (
      <div>
        <Helmet title={titles.links} titleTemplate={titles.titleTemplate} />
        <section className="links">
          <Title header="h1" title="リンク集" />
          {links || links.length
            ?
              <div className="links__content">
                {links.map(item => {
                  return(
                    <div className={classNames({'links__item': true, 'no-url': !item.has_url, 'has-url': item.has_url})} key={item.name}>
                      {item.has_url
                        ?
                          <a href={item.url} target="_blank">
                            <figure style={{'backgroundImage': `url(${item.logo})`}}>
                              <figcaption>{item.name}</figcaption>
                            </figure>
                            <span className="links__item__overlay">
                              <Icon name="external-link" />
                              <div className="links__item__overlay__desc">
                                <p>Webサイトへ移動する</p>
                              </div>
                            </span>
                          </a>
                        :
                          <div>
                            <figure>
                              <figcaption>{item.name}</figcaption>
                            </figure>
                            <span className="links__item__overlay">
                              <div className="links__item__overlay__desc" dangerouslySetInnerHTML={{__html: item.desc}} />
                            </span>
                          </div>
                      }
                    </div>
                  )
                })}
              </div>
            : ''
          }
        </section>
      </div>
    )
  }
}

class LinksFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page] = allFetches.value;
      page = page[0];

      return (
        <Links page={page} />
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.base_url}/pages?slug=links`
}))(LinksFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Links.js
 **/